/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Expense_Category_Used_By_Rule_ErrorInputs */

const vi_expense_category_used_by_rule_error = /** @type {(inputs: Expense_Category_Used_By_Rule_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Danh mục đang được ${i?.count} quy tắc sử dụng. Đổi hoặc xoá các quy tắc đó trước.`)
};

/**

* @param {Expense_Category_Used_By_Rule_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const expense_category_used_by_rule_error = /** @type {((inputs: Expense_Category_Used_By_Rule_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Expense_Category_Used_By_Rule_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_expense_category_used_by_rule_error(inputs)
});